"use strict";

import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".gallery").forEach((container) => {

        container.querySelectorAll(".gallery-slider").forEach((sliderEl) => {
            new Swiper(sliderEl, {
                modules: [Navigation, Pagination],
                slidesPerView: "auto",
                spaceBetween: 20,
                observer: true,
                observeParents: true,
                navigation: {
                    nextEl: sliderEl.querySelector('.arrows-next'),
                    prevEl: sliderEl.querySelector('.arrows-prev'),
                }
            });
        });

    });
});